var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.89498H12C11.45 6.89498 11 7.34498 11 7.89498C11 8.44498 11.45 8.89498 12 8.89498H14V19.895H2V8.89498H4C4.55 8.89498 5 8.44498 5 7.89498C5 7.34498 4.55 6.89498 4 6.89498H2C0.9 6.89498 0 7.79498 0 8.89498V19.895C0 20.995 0.9 21.895 2 21.895H14C15.1 21.895 16 20.995 16 19.895V8.89498C16 7.79498 15.1 6.89498 14 6.89498Z",
    fill: "#CFD2D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.895C8.55 14.895 9 14.445 9 13.895V3.89498H10.79C11.24 3.89498 11.46 3.35498 11.14 3.04498L8.35 0.25498C8.15 0.0549805 7.84 0.0549805 7.64 0.25498L4.85 3.04498C4.54 3.35498 4.76 3.89498 5.21 3.89498H7V13.895C7 14.445 7.45 14.895 8 14.895Z",
    fill: "#CFD2D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.c9eb7205df26013bc2a965b4e9c0e810.svg";
export { ForwardRef as ReactComponent };